export const VARIANCE_CODES = {
  PICKER_POPOVER: 'variance-code-picker-popover',
  SEARCH_INPUT: 'variance-code-search-input',
  CLEAR_SEARCH_BUTTON: 'variance-code-clear-search-button',
  VARIANCE_CODE_LIST_ITEM: 'variance-code-list-item',
  VARIANCE_CODE_CHECKBOX: 'variance-code-checkbox',
  VARIANCE_CODE_CHECKBOX_LABEL: 'variance-code-checkbox-label',
  NO_RESULTS_MESSAGE: 'variance-code-no-results-message',
  PILL_CONTAINER: 'variance-code-pill-container',
  PILL_CONTENT_WRAP: 'variance-code-pill-content-wrap',
  PILL_NUMBER: 'variance-code-pill-number',
  PILL_TEXT: 'variance-code-pill-text',
  PILLS_LIST_CONTAINER: 'variance-code-pills-list-container',
  MORE_PILLS_TOOLTIP_CONTENT: 'variance-code-more-pills-tooltip-content',
  MORE_PILLS_INDICATOR: 'variance-code-more-pills-indicator',
  ARCHIVED_DIALOG: 'variance-code-archived-dialog',
  ARCHIVED_DIALOG_CLOSE_BUTTON: 'variance-code-archived-dialog-close-button',
  ARCHIVED_DIALOG_CLOSE_ICON: 'variance-code-archived-dialog-close-icon',
  ARCHIVED_DIALOG_TITLE: 'variance-code-archived-dialog-title',
  ARCHIVED_DIALOG_CONTENT: 'variance-code-archived-dialog-content',
  ARCHIVE_CELL_RENDERER: 'variance-code-archive-cell-renderer',
  ARCHIVE_ICON_WRAPPER: 'variance-code-archive-icon-wrapper',
  ARCHIVE_ICON: 'variance-code-archive-icon',
  UNARCHIVE_ICON: 'variance-code-unarchive-icon',
  COLOR_CELL_RENDERER: 'variance-code-color-cell-renderer',
  COLOR_BOX: 'variance-code-color-box',
  COLOR_CIRCLE: 'variance-code-color-circle',
  COLOR_ARROW: 'variance-code-color-arrow',
  COLOR_PICKER_POPOVER: 'variance-code-color-picker-popover',
  NAME_CELL_RENDERER: 'variance-code-name-cell-renderer',
  NAME_INPUT_FIELD: 'variance-code-name-input-field',
  NAME_TEXT: 'variance-code-name-text',
  CODE_CELL_RENDERER: 'variance-code-code-cell-renderer',
  CODE_INPUT_FIELD: 'variance-code-code-input-field',
  CODE_TEXT: 'variance-code-code-text',
  LIBRARY_GRID_CONTAINER: 'variance-code-library-grid-container',
  LIBRARY_GRID: 'variance-code-library-grid',
  EMPTY_STATE: 'variance-code-empty-state',
  ADD_OPTION_BUTTON: 'variance-code-add-option-button',
  ARCHIVED_CODES_BUTTON: 'variance-code-archived-codes-button',
  ACTION_BUTTONS_WRAPPER: 'variance-code-action-buttons-wrapper'
} as const;
